var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUnderline = function SvgUnderline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 0H9.25C9.09375 0 9 0.125 9 0.25V0.75C9 0.90625 9.09375 1 9.25 1H11V8C11 10.2188 9.1875 12 7 12C4.78125 12 3 10.2188 3 8V1H4.75C4.875 1 5 0.90625 5 0.75V0.25C5 0.125 4.875 0 4.75 0H0.25C0.09375 0 0 0.125 0 0.25V0.75C0 0.90625 0.09375 1 0.25 1H2V8C2 10.7812 4.21875 13 7 13C9.75 13 12 10.7812 12 8V1H13.75C13.875 1 14 0.90625 14 0.75V0.25C14 0.125 13.875 0 13.75 0ZM13.75 15H0.25C0.09375 15 0 15.125 0 15.25V15.75C0 15.9062 0.09375 16 0.25 16H13.75C13.875 16 14 15.9062 14 15.75V15.25C14 15.125 13.875 15 13.75 15Z",
    fill: "#333333"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnderline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/underline.f052d8a5.svg";
export { ForwardRef as ReactComponent };